module.exports = __webpack_public_path__ + "static/chair3-1d895006e8b7f1c0ef7eb8c9d91e36b0.jpg";